<template>
  <main>
    <PageIntro
      :heading="'Activate your account'"
      :body="'<p>Your account has been created. To activate the account, please follow the verification link contained within the email we’ve sent to the email address used during registration.</p>'" /> 
    <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
    
    <v-layout row align-center mx-1>
              <router-link to="/send-confirm-code" class="text-button">Resend verification link</router-link>
              <v-spacer />
            </v-layout>
      </v-flex></v-layout></v-container>
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      PageIntro,
      FooterShout
    }
  }
</script>
